import React, { useContext, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { SessionContext } from '../providers/SessionProvider/context';
import ActivityIndicator from '../components/indicators';
import { UIView } from '../utils/styled/styled';
import Lessons from '../screens/Lessons';
import Login from '../screens/auth/Login';
import DailyAluxCalendar from '../screens/DailyAluxCalendar';
import ContentGroups from '../screens/ContentGroups';
import ManageContentGroup from '../screens/ContentGroups/ManageContentGroup';
import UserLookup from '../screens/UserLookup';
import UserDetails from '../screens/UserLookup/UserDetails';
import AppConfiguration from '../screens/AppConfiguration';
import BannerOffers from '../screens/BannerOffers';
import Campaigns from '../screens/Campaigns';
import Authors from '../screens/ContentManagement/components/Authors';
import ContentManagement from '../screens/ContentManagement';
import Forms from '../screens/Forms';
import { Prompt } from '../screens/Prompt/Prompt';
import LessonStats from '../screens/LessonStats/LessonStats';
import Networks from '../screens/Networks';
import UserPaths from '../screens/UserPaths';
import Transcripts from '../screens/Transcripts';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '../utils/queryClient/queryClient';

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

export const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const ProjectRoutes = () => {
  const { isLoggedIn } = useContext(SessionContext);

  const routes = isLoggedIn ? (
    <SentryRoutes>
      <Route path={'/lessons'} element={<Lessons />} />
      <Route path={'/daily-alux'} element={<DailyAluxCalendar />} />
      <Route path={'/content-groups'} element={<ContentGroups />} />
      <Route path={'/content-groups/manage'} element={<ManageContentGroup />} />
      <Route path={'/user-lookup'} element={<UserLookup />} />
      <Route path={'/user-lookup/:id'} element={<UserDetails />} />
      <Route path={'/app-configuration'} element={<AppConfiguration />} />
      <Route path={'/banner-offers'} element={<BannerOffers />} />
      <Route path={'/campaigns'} element={<Campaigns />} />
      <Route path={'/authors'} element={<Authors />} />
      <Route path={'/content-management/*'} element={<ContentManagement />} />
      <Route path={'/forms'} element={<Forms />} />
      <Route
        path={'/prompt'}
        element={
          <QueryClientProvider client={queryClient}>
            <Prompt />
          </QueryClientProvider>
        }
      />
      <Route path={'/lesson-stats'} element={<LessonStats />} />
      <Route path={'/networks'} element={<Networks />} />
      <Route path={'/user-paths'} element={<UserPaths />} />
      <Route path={'/transcripts'} element={<Transcripts />} />
      <Route path={'*'} element={<Navigate to={'/lessons'} replace />} />
    </SentryRoutes>
  ) : (
    <SentryRoutes>
      <Route path={'/login'} element={<Login />} />
      <Route path={'*'} element={<Navigate to={'/login'} replace />} />
    </SentryRoutes>
  );

  return (
    <Router>
      <Suspense
        fallback={
          <UIView displayFlex alignItems='center' justifyContent='center' fullWidth fullScreenHeight>
            <ActivityIndicator />
          </UIView>
        }>
        {routes}
      </Suspense>
    </Router>
  );
};

export default ProjectRoutes;
